import { LoadingOverlay } from '@mantine/core';
import { Navigate, useParams } from 'react-router-dom';

import { useSelectedAssetId } from 'src/Hooks/Shared/useSelectedAssetId';

/**
 * « Entre nous » a déménagé sous /asset/:assetId/community. Les anciens liens et les
 * notifications push pointent encore sur /community : on les renvoie vers le bien
 * favori en conservant le post et le commentaire ciblés.
 */
const RedirectToAssetCommunity = () => {
  const { postId, commentId } = useParams<{ postId?: string; commentId?: string }>();
  const assetId = useSelectedAssetId();

  if (!assetId) {
    return <LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  const base = `/asset/${assetId}/community`;
  const target = postId
    ? `${base}/post/${postId}${commentId ? `/comment/${commentId}` : ''}`
    : base;

  return <Navigate to={target} replace />;
};

export default RedirectToAssetCommunity;
